import { render, staticRenderFns } from "./scanerror.vue?vue&type=template&id=98fad52a&scoped=true"
import script from "./scanerror.vue?vue&type=script&lang=js"
export * from "./scanerror.vue?vue&type=script&lang=js"
import style0 from "./scanerror.vue?vue&type=style&index=0&id=98fad52a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fad52a",
  null
  
)

export default component.exports